"use client";

import { Children } from "react";
// @ts-ignore
import styles from "./../styles/components/parts/Button.module.css";

interface Props {
  className?: string;
  variable?: "gabage" | "text";
  children: React.ReactNode;
  action?: () => void;
}

export default function ButtonIcon({
  className,
  variable,
  children,
  action,
}: Props) {
  return (
    <button
      className={`${styles.buttonIcon} ${
        variable === "gabage" && styles.buttonIcon__gabage
      } ${className}`}
      onClick={() => action?.()}
    >
      {children}
    </button>
  );
}
